<template>
    <div class="page-content" id="patrol-form">
        <Titlebar :incrustation="'fa-history'">
            <h1>Test Planning</h1>
        </Titlebar>
        <div class="container-fluid full-height col-no-padding calendar-container">
            <DatePicker :position="{v:'top',h:'center'}" v-model="selectedDate"></DatePicker>
            <Calendar ref="calendar" :config="config" @viewRender="viewRender" @eventRender="eventRender" @dayClick="dayClick"
                      @eventClick="eventClick"></Calendar>

        </div>
        <Toolbar>
            <Btn class="default">
                <i class="fa fa-clock-o"></i>&nbsp;&nbsp;&nbsp;{{ $t('patrol.planning.btns.add') }}
            </Btn>
        </Toolbar>
        <div ref="popup" class="calendar-popup" :class="{show:showPopup}" v-on-clickaway="closePopup">
            <div class="calendar-popup-arrow"></div>
            <div class="calendar-popup-inner">
                <div class="popup-row">
                    <label>Ronde</label><span>{{ eventInfos.title }}</span>
                </div>
                <div class="popup-row">
                    <label>Ressource</label><span>{{ eventInfos.properties.resource.name }}</span>
                </div>
                <div class="popup-row">
                    <label>Date</label><span>{{ getStartDateFormated(eventInfos.start) }}</span>
                </div>
                <div class="popup-row">
                    <label>Répétition</label><span>{{ getRepeatLabel(eventInfos.properties.repeat) }}</span>
                </div>
                <div class="popup-row">
                    <label>État</label><span
                        :class="'patrol-state-'+eventInfos.properties.state">{{ $t("patrol.planning.states.state" + eventInfos.properties.state)
                    }}</span>
                </div>
                <div class="popup-buttons">
                    <Btn class="primary accent" :title="$t('patrol.planning.btns.popup.compare')"><i class="fa fa-eye"></i></Btn>
                    <Btn class="secondary" :title="$t('patrol.planning.btns.popup.editEvent')"><i class="fa fa-pencil"></i></Btn>
                    <Btn class="secondary" :title="$t('patrol.planning.btns.popup.editSeries')" v-show="eventInfos.properties.seriesId != null"><i
                            class="fa fa-calendar"></i>
                    </Btn>
                    <Btn class="secondary danger" :title="$t('patrol.planning.btns.popup.delete')"><i class="fa fa-trash"></i></Btn>
                </div>
            </div>
        </div>
        <div ref="addMask" class="calendar-add-mask" :class="{show:showMask}" @mouseout="closeAddMask" @click="handleAddToDate">
            <i class="fa fa-plus"></i>
        </div>
        <Modal ref="modalAddEvent" :width="'400px'" :height="'710px'">
            <span slot="header" v-html="$t('patrol.planning.titles.add.event')"></span>
            <div slot="content">
                <PlanningForm ref="modalAddEventForm" :patrols="patrols" :date="selectedDate" @close="handleCloseModalAddEvent"></PlanningForm>
            </div>
        </Modal>
    </div>

</template>

<script>
    import axios from 'axios';
    import API from '@/services/API.js';
    import Auth from '@/services/auth.js'
    import Utils from '@/services/utils.js'

    import Calendar from '@/components/ui/fullcalendar/Calendar'
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";

    import Btn from "@/components/ui/Button";
    import Modal from '@/components/ui/Modal';
    import DatePicker from '@/components/ui/datetime/DatePicker';

    import PlanningForm from "@/views/patrols/PlanningForm";

    import zepto from 'webpack-zepto';
    import moment from 'moment';

    import {mixin as clickaway} from 'vue-clickaway';

    const bottomBorder = 10;
    var defaultView = 'month';

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {
            if(window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_BPZ_PLANNING_VIEW') != null){
                this.config.defaultView = window.V.$localStorage.get('BPZ_' + Auth.getHash() + '_BPZ_PLANNING_VIEW');
            }
        },
        beforeUpdate: function () {

        },
        components: {
            Titlebar,
            Toolbar,
            Calendar,
            Btn,
            Modal,
            DatePicker,
            PlanningForm
        },
        computed: {
            eventInfos() {
                if (this.selectedEvent != null) {
                    return this.selectedEvent;
                }
                else {
                    return {
                        "id": null,
                        "title": "",
                        "allDay": false,
                        "start": "",
                        "end": "",
                        "properties": {
                            "seriesId": null,
                            "resource": {
                                "id": null,
                                "name": "",
                                "type": "datis"
                            },
                            "repeat": null,
                            "state": null
                        }
                    }
                }
            }
        },
        created: function () {

        },
        data() {
            return {

                config: {
                    allDaySlot: false,
                    columnFormat: 'dddd',
                    defaultView: defaultView,
                    displayEventEnd: false,
                    eventLimit: true,
                    events: {
                        url: 'http://localhost:3001/beepiz/patrols/events',
                        headers: {
                            'Authorization': 'Bearer 123456789'
                        }
                    },
                    firstDay: 1,
                    fixedWeekCount: false,
                    header: {
                        left: 'prev next today',
                        center: 'title',
                        right: 'month agendaWeek agendaDay'
                    },
                    height: "parent",
                    locale: 'fr',
                    navLinks: true,
                    navLinkDayClick: 'agendaDay',
                    navLinkWeekClick: 'agendaWeek',
                    slotEventOverlap: false,
                    timeFormat: 'H[h](mm)',
                    views: {
                        agendaWeek: {
                            columnFormat: 'dddd D',
                        }
                    },
                    weekNumbers: true,
                    weekNumbersWithinDays: true,
                },
                containerPos: null,
                toolbarPos: null,
                showPopup: false,
                showMask: false,
                selectedEvent: null,
                selectedDate: null,
                patrols: [],
            }
        },
        destroyed: function () {

        },
        methods: {
            viewRender(context, view, element) {
                zepto('.fc-scroller').on('scroll',()=>{
                    this.showPopup = false;
                })
                window.V.$localStorage.set('BPZ_' + Auth.getHash() + '_BPZ_PLANNING_VIEW', view.name)
            },
            eventRender(context, event, element) {
                if (event.properties) {
                    element[0].classList.add('patrol-state-' + event.properties.state);
                }

            },
            eventClick(context, event, jsEvent, view) {
                jsEvent.stopPropagation();
                jsEvent.preventDefault();
                this.selectedEvent = event;


                this.setPopupPosition(jsEvent.currentTarget);
                this.showPopup = true;


            },
            dayClick(context, date,jsEvent, view, resourceObj){
                if(this.showPopup === false){


                    let elmt = zepto(zepto(context[0]));

                    if(view.name == 'month'){
                        this.$refs.addMask.style.top = elmt.offset().top+'px';
                        this.$refs.addMask.style.left = (elmt.offset().left - 80)+'px';
                        this.$refs.addMask.style.width = elmt.offset().width+'px';
                        this.$refs.addMask.style.height = elmt.offset().height+'px';
                    }
                    else if(view.name == 'agendaWeek' || view.name == 'agendaDay'){
                        var time = moment(date).format('HH:mm:ss');
                        var elmt2 = zepto('.fc-slats tr[data-time="'+time+'"]');
                        this.$refs.addMask.style.top = elmt2.offset().top+'px';
                        this.$refs.addMask.style.left = (elmt.offset().left - 80)+'px';
                        this.$refs.addMask.style.width = elmt.offset().width+'px';
                        this.$refs.addMask.style.height = (elmt2.offset().height * 2)+'px';
                    }


                    this.$refs.addMask.setAttribute('data-date',date);
                    this.showMask = true;
                }
            },
            setPopupPosition(targetObj) {
                var child = zepto(targetObj);
                var childPos = child.offset();
                var popup = zepto(this.$refs.popup)[0];
                var popupArrow = zepto('.calendar-popup-arrow')[0];

                var container = zepto('.page-content')[0];
                this.containerPos = zepto(container).offset();
                var toolbar = zepto('.page-content .toolbar')[0];
                this.toolbarPos = zepto(toolbar).offset();

                var childOffset = {
                    top: childPos.top - this.containerPos.top,
                    left: childPos.left - this.containerPos.left
                }

                var position = {
                    top: childOffset.top,
                    left: (childOffset.left + childPos.width + 7)
                }

                var arrowTop = (targetObj.offsetHeight - popupArrow.offsetHeight) / 2;
                var arrowLeft = Math.floor(popupArrow.offsetWidth) * (-1);
                popupArrow.style.transform = "scale(1,1)";

                if (childOffset.top + popup.offsetHeight > this.containerPos.height - this.toolbarPos.height - bottomBorder - 10) {
                    position.top = (this.containerPos.height - this.toolbarPos.height - popup.offsetHeight - bottomBorder - 10);
                    arrowTop += (childOffset.top + popup.offsetHeight) - (this.containerPos.height - this.toolbarPos.height - bottomBorder - 10);
                }

                if(childPos.width > (this.containerPos.width / 2)){
                    position.left = (childOffset.left + (childPos.width / 2) + 7);
                }
                else{
                    if (position.left + popup.offsetWidth >  this.containerPos.width - this.containerPos.left - bottomBorder - 10) {
                        position.left = (childOffset.left - popup.offsetWidth - 7);
                        arrowLeft = popup.offsetWidth;
                        popupArrow.style.transform = "scale(-1,1)";
                    }
                }




                this.$refs.popup.style.left = position.left + 'px';
                this.$refs.popup.style.top = position.top + 'px';

                popupArrow.style.top = arrowTop + 'px';
                popupArrow.style.left = arrowLeft + 'px';
            },
            getStartDateFormated(date){
                if(date != null){
                    return moment(date).format('[Le] DD/MM/YYYY [à] H[h](mm)');
                }
                return "";
            },
            getRepeatLabel(repeatObj) {
                if (repeatObj != null) {
                    switch (repeatObj.type) {
                        case 1:
                            return "Tous les jours";
                            break;
                        case 2:
                            return "Toutes les semaines";
                            break;
                        case 3:
                            return "Tous les mois";
                            break;
                    }
                }
                return "Aucune";
            },
            handleAddToDate(){
                var date = this.$refs.addMask.getAttribute('data-date');
                //alert('ADD '+moment(date).tz('Europe/Paris').format('DD/MM/YYYY HH:mm:ss'));
                this.selectedDate = moment(date);
                this.closeAddMask();
                this.showModal();
            },
            closePopup(event){
                this.showPopup = false;
            },
            closeAddMask(event){
                this.$refs.addMask.removeAttribute('data-date');
                this.showMask = false;
            },
            showModal(){
                this.$refs.modalAddEvent.show(() => {
                    this.$refs.modalAddEventForm.resetForm();
                });
            },
            handleCloseModalAddEvent(){
                this.$refs.modalAddEvent.hide();
            },
            loadPatrols: function () {
                var config = {
                    perpage: 999999,
                }
                axios.get(API.endpoints.patrols.index + API.constructQueryParams(config))
                    .then(response => {
                        this.patrols = response.data.data;
                        window.Vfc.$refs.loading.hide();
                    })
                    .catch(e => {
                        window.Vfc.$refs.loading.hide();
                    })
            }
        },
        mixins: [clickaway],
        mounted: function () {
            this.loadPatrols();
            //window.Vfc.$refs.loading.hide();

            var container = zepto('.page-content')[0];
            this.containerPos = zepto(container).offset();
            var toolbar = zepto('.page-content .toolbar')[0];
            this.toolbarPos = zepto(toolbar).offset();


            //this.showModal();

        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {
            selectedDate(newVal){
                this.$refs.calendar.callMethod('gotoDate',moment(newVal));
            }
        }
    }
</script>

<style lang="scss">


</style>
